<div class="widget-container" #SankeyChart>
    <app-sankey-chart
    [headerConfig]="item.config?.widget_header_config"
    [heading]="heading"
    [config]="config"
    [data]="data"
    [item]="item"
    [pageKey]="pageKey"
    [triageTotaldata]="triageTotaldata"
    >
    </app-sankey-chart>
</div>